import { render } from "./TradesView.vue?vue&type=template&id=57717c3f&scoped=true&ts=true"
import script from "./TradesView.vue?vue&type=script&lang=ts"
export * from "./TradesView.vue?vue&type=script&lang=ts"

import "./TradesView.vue?vue&type=style&index=0&id=57717c3f&scoped=true&lang=css"

import exportComponent from "D:\\projects\\wintick\\wintick-applets-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57717c3f"]])

export default __exports__